var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0405 15.5549C12.0405 18.4066 14.3522 20.7183 17.2038 20.7183C20.0554 20.7183 22.3671 18.4066 22.3671 15.5549C22.3671 12.7033 20.0554 10.3916 17.2038 10.3916C14.3522 10.3916 12.0405 12.7033 12.0405 15.5549ZM12.0405 15.5549C12.0405 14.3923 12.4247 13.3195 13.0732 12.4564V3.16298M12.0405 15.5549C12.0405 16.4073 12.247 17.2113 12.6127 17.9199C11.7428 18.6547 9.73337 19.1693 7.39352 19.1693C4.25673 19.1693 1.71387 18.2446 1.71387 17.1039V3.16298M13.0732 3.16298C13.0732 4.30363 10.5303 5.22831 7.39352 5.22831C4.25673 5.22831 1.71387 4.30363 1.71387 3.16298M13.0732 3.16298C13.0732 2.02233 10.5303 1.09766 7.39352 1.09766C4.25673 1.09766 1.71387 2.02233 1.71387 3.16298M1.71387 12.457C1.71387 13.5976 4.25673 14.5223 7.39352 14.5223C9.65402 14.5223 11.6061 14.0421 12.5203 13.3469M13.0732 7.80997C13.0732 8.95062 10.5303 9.87529 7.39352 9.87529C4.25673 9.87529 1.71387 8.95062 1.71387 7.80997",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack);
export default __webpack_public_path__ + "static/media/stack.319c6b8ada80554c67c83348617cbdca.svg";
export { ForwardRef as ReactComponent };